export const getDatetimeOrdinalSuffix = (day: number) => {
  const th = 'th';
  const rd = 'rd';
  const nd = 'nd';
  const st = 'st';

  if (day === 11 || day === 12 || day === 13) return th;

  const lastDigit = day.toString().slice(-1);

  switch (lastDigit) {
    case '1':
      return st;
    case '2':
      return nd;
    case '3':
      return rd;
    default:
      return th;
  }
};
